import { render, staticRenderFns } from "./productionView.vue?vue&type=template&id=35685941&scoped=true"
import script from "./productionView.vue?vue&type=script&lang=js"
export * from "./productionView.vue?vue&type=script&lang=js"
import style0 from "./productionView.vue?vue&type=style&index=0&id=35685941&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35685941",
  null
  
)

export default component.exports